import {useQuery} from "@apollo/client";
import {
    ReportListResponse,
    GET_REPORT_LISTING,
    ReportFileType,
} from "../graphql/queries/getReportFileListing";
import {useEffect, useState} from "react";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";

export interface ReportFileFiltersType {
    type?: number;
    name?: string;
    reportDate?: [string | null, string | null] | null;
    operatorId?: number;
}

export interface ReportQueryResult {
    reportFileData: ReportFileType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useDeliveryReportFileQuery = (
    filters: ReportFileFiltersType,
    currentPage: number,
    pageSize: number,
    skip: boolean = false
): ReportQueryResult => {
    const [reportFileData, setReportFileData] = useState<ReportFileType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const timeRanges = {
            reportDate: formatTimeRangeToISO(filters.reportDate),
        };

        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "createdAt",
                sortDirection: "DESC"
            }
        };
    };

    const { data, loading: queryLoading, refetch } = useQuery<ReportListResponse>(GET_REPORT_LISTING,
        {
            variables: buildQueryVariables(),
            skip: skip
        });

    useEffect(() => {
        if (data?.getReportFileListing) {
            const responseData = data.getReportFileListing.content || [];
            setReportFileData(responseData);
            setLoading(false);

            const totalElements = parseInt(data.getReportFileListing.totalElements.toString()) || 0;
            setTotal(totalElements);
        }
    }, [data]);

    return {
        reportFileData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};